import estilos from "./StackTecnologica.module.css";
import { habilidades } from "../../data/habilidades";

const StackTecnologica = () => {
  return (
    <section id="stack" className={estilos.secao}>
      <span className={estilos.etiqueta}>// Stack Tecnológica</span>
      <h2 className={estilos.titulo}>Tecnologias</h2>

      <div className={estilos.grade}>
        {habilidades.map((categoria) => (
          <div key={categoria.categoria} className={estilos.categoriaCard}>
            <h3 className={estilos.categoriaNome}>{categoria.categoria}</h3>
            <ul className={estilos.listaHabilidades}>
              {categoria.itens.map((item) => (
                <li key={item.nome} className={estilos.habilidade}>
                  {item.nome}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StackTecnologica;
